export default function cleanMetadataKeys(metadata) {
  return Object.keys(metadata).reduce((all, key) => (
    { ...all, [key.replace(/^_/, '')]: metadata[key] }
  ), {});
}
